<template>
    <div v-show="visible">
        <el-dialog title="修改" :visible.sync="visible" :close-on-click-modal="false" :before-close="dialogClose" width="65%">    
            <el-form ref="form" :model="form" :rules="rules" label-width="85px">
                <div style="font-size:14px;margin-bottom:10px;font-weight:bold;">基本信息：</div>    
                <el-row :gutter="15">
                    <el-col :lg="8" :xl="8">
                        <el-form-item prop="name" label="姓名">
                            <el-input v-model="form.name" maxlength="50"></el-input>
                        </el-form-item>
                    </el-col>


                    <el-col :lg="8" :xl="8">
                        <el-form-item prop="deptId" label="所属机构">
                            <el-cascader
                                :options="depts"
                                v-model="form.deptId"
                                :props="props"
                                collapse-tags
                                clearable
                                @change="onDeptChange"></el-cascader>
                        </el-form-item>
                    </el-col>

                    <el-col :lg="8" :xl="8">
                        <el-form-item prop="cardNo" label="卡号">
                            <el-select
                                v-model="form.cardNo"
                                clearable
                                filterable
                                remote
                                reserve-keyword
                                :disabled="$util.isNotEmpty(initCardNo)"
                                :remote-method="onCardNoRemote"
                                :loading="cardNoLoading"
                                popper-class="student-cardno-dropdown-update"
                                placeholder="请选择卡号"
                                style="width:100%;"
                                @visible-change="onCardNoVisibleChange">
                                <el-option
                                    v-for="item in cardNoOptions"
                                    :key="item.cardNo"
                                    :label="item.cardNo"
                                    :value="item.cardNo">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="15">
                    <el-col :lg="8" :xl="8">
                        <el-form-item prop="sex" label="性别">
                            <el-select v-model="form.sex" clearable placeholder="请选择">
                                <el-option v-for="item in sexs" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item prop="identityCard" label="身份证">
                            <el-input v-model="form.identityCard" :readonly="true" maxlength="50"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item prop="studentType" label="学生类型">
                            <el-select v-model="form.studentType" clearable placeholder="请选择">
                                <el-option v-for="item in studentTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="15">
                    <el-col :lg="8" :xl="8">
                        <el-form-item prop="classNo" label="班内学号">
                            <el-input v-model="form.classNo" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :lg="8" :xl="8">
                        <el-form-item prop="roomNumber" label="宿舍房间号">
                             <el-input v-model="form.roomNumber" maxlength="200" :disabled="form.studentType != 1"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :lg="8" :xl="8">
                         <el-form-item prop="studentId" label="学籍辅号">
                            <el-input v-model="form.studentId" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="15">
                    <el-col :lg="8" :xl="8">
                        <el-form-item prop="expertise" label="有何专长">
                            <el-input v-model="form.expertise" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :lg="8" :xl="8">
                        <el-form-item prop="hobby" label="爱好">
                             <el-input v-model="form.hobby" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :lg="8" :xl="8">
                        <el-form-item prop="graduationDate" label="毕业年月">
                            <el-input v-model="form.graduationDate" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="15">
                    <el-col :lg="8" :xl="8">
                        <el-form-item prop="orderNum" label="排序号">
                            <el-input v-model="form.orderNum" maxlength="100" type="number"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <div style="height: 1px;"></div>
                    </el-col>
                </el-row>

                <div style="font-size:14px;margin-bottom:10px;font-weight:bold;">通讯信息：</div>
                <el-row :gutter="15">
                    <el-col :lg="8" :xl="8">
                        <el-form-item prop="mobile1" label="移动电话">
                             <el-input v-model="form.mobile1" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8"><div style="height: 1px;"></div></el-col>
                    <el-col :lg="8" :xl="8"><div style="height: 1px;"></div></el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取消</el-button>
                <el-button type="primary" :loading="loading" @click="save()">确定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>

<script>
    import http from '../../../../common/http';

    export default {
        data(){
            return{
                loading:false,
                visible:false,
                props: { multiple: true,  checkStrictly: true },
                depts:[],
                deptId:"",
                cardNoOptions:[],
                cardNoLoading:false,
                cardNoKeyword:"",
                cardNoPage:1,
                cardNoPageSize:30,
                cardNoTotal:0,
                cardNoSchoolId:"",
                initCardNo:"",
                sexs:[{
                    value: 1,
                    label: '男'
                }, {
                    value: 2,
                    label: '女'
                }],
                studentTypes:[{
                    value: 1,
                    label: '寄宿生'
                }, {
                    value: 2,
                    label: '走读生'
                }, {
                    value: 3,
                    label: '寄午生'
                }, {
                    value: 4,
                    label: '艺考生'
                }, {
                    value: 5,
                    label: '休假生'
                }, {
                    value: 0,
                    label: '其他'
                }],
                form:{
                    id:"",
                    studentId:"",
                    name:"",
                    cardNo:"",
                    personType:1,
                    deptId:"",
                    sex:"",
                    identityCard:"",
                    classNo:"",
                    studentType:"",
                    roomNumber:"",
                    postDescrible:"",
                    office:"",
                    expertise:"",
                    hobby:"",
                    graduationDate:"",
                    orderNum:"",
                    mobile1:"",
                },
                rules:{
                    name: [
                        { required: true, message: '请输入姓名', trigger: 'blur' }
                    ],
                    // cardNo: [
                    //     { required: true, message: '请选择卡号', trigger: 'change' }
                    // ],
                    deptId: [
                        {type: 'array', required: true, message: '请选择机构', trigger: 'blur' }
                    ],
                    mobile1:[
                        { validator: this.checkPhone, trigger: 'blur' }
                    ],
                }
            }
        },
        created:function () {
        },
        methods:{
            init(row){
                this.visible=true;
                this.loading=false;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.cardNoOptions = [];
                this.cardNoLoading = false;
                this.cardNoKeyword = "";
                this.cardNoPage = 1;
                this.cardNoTotal = 0;
                this.cardNoSchoolId = "";
                this.initCardNo = "";
                // 查询用户信息
                let url  = this.getUserUrl
                let reqData = {
                   id: row.id
                }
                this.apiPost(url,reqData).then((res) => {
                    if(res.status==200){
                        let tempData = res.data
                        this.form.id = tempData.id;
                        this.form.username = tempData.username;
                        this.form.studentId = tempData.studentId == null?"":tempData.studentId;
                        this.form.name = tempData.name == null?"":tempData.name;
                        this.form.personType = tempData.personType== null?"":tempData.personType;
                        this.roleId = tempData.roleIdstr== null?"":tempData.roleIdstr;
                        this.deptId = tempData.deptIdstr== null?"":tempData.deptIdstr;
                        this.form.sex = tempData.sex== null?"":tempData.sex;
                        this.form.identityCard = tempData.identityCard== null?"":tempData.identityCard;
                        this.form.cardNo = tempData.cardNo== null?"":tempData.cardNo;
                        this.initCardNo = tempData.cardNo== null?"":tempData.cardNo;
                        this.form.classNo = tempData.classNo== null?"":tempData.classNo;
                        this.form.studentType=tempData.studentType== null?"":tempData.studentType;
                        this.form.roomNumber = tempData.roomNumber== null?"":tempData.roomNumber;
                        this.form.postDescrible = tempData.postDescrible== null?"":tempData.postDescrible;
                        this.form.office = tempData.office== null?"":tempData.office;
                        this.form.expertise = tempData.expertise== null?"":tempData.expertise;
                        this.form.hobby = tempData.hobby== null?"":tempData.hobby;
                        this.form.graduationDate = tempData.graduationDate== null?"":tempData.graduationDate;
                        this.form.orderNum = tempData.orderNum== null?"1":tempData.orderNum;
                        this.form.mobile1 = tempData.mobile1== null?"":tempData.mobile1;
                        this.form.directSuperiors = tempData.directSuperiors== null?"":tempData.directSuperiors;
                        this.form.directSuperiorsLabel = tempData.directSuperiorsName== null?"":tempData.directSuperiorsName;
                        this.form.cardNo = tempData.cardNo== null?"":tempData.cardNo;
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                    
                    // 初始值
                    this.getDeptCascader()
                },(err)=>{
                    console.log(err)
                })
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            async checkPhone(rule,value,callback){
                let phoneReg = /^1[2|3|4|5|6|7|8|9][0-9]{9}$/
                if(this.$util.isEmpty(value)){
                    callback();
                    return;
                }
                if (phoneReg.test(value)) {
		          callback()
		        } else {
		          callback(new Error('移动电话格式不正确'))
		        }
            },
            filterDeptOptions(nodes){
                if(!Array.isArray(nodes)){
                    return [];
                }
                let res = [];
                for(let i=0;i<nodes.length;i++){
                    let n = nodes[i];
                    let children = this.filterDeptOptions(n.children);
                    let match = (n.parentId === 0) || (this.$util.isNotEmpty(n.label) && (n.label.indexOf('年级') > -1 || n.label.indexOf('不在班学生组') > -1));
                    if(match || (children && children.length > 0)){
                        res.push(Object.assign({}, n, { children }));
                    }
                }
                return res;
            },
            getDeptCascader(){
                let url  = this.getDeptCascaderUrl;
                let data = {};
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                      this.depts = this.filterDeptOptions(res.data.selects);
                      if(this.$util.isNotEmpty(this.deptId)){
                          this.form.deptId = this.getName(this.deptId, this.depts);
                      }
                      // 回显时根据学校加载卡号列表
                      let schoolId = this.getSchoolIdFromDeptVal(this.form.deptId);
                      if(this.$util.isNotEmpty(schoolId)){
                          this.cardNoSchoolId = schoolId;
                          this.resetCardNoQuery();
                          this.queryCardNoList(false, true);
                      }
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getSchoolIdFromDeptVal(val){
                if(!Array.isArray(val) || val.length === 0){
                    return "";
                }
                let path = Array.isArray(val[0]) ? val[0] : val;
                return path && path.length > 0 ? path[0] : "";
            },
            onDeptChange(val){
                let schoolId = this.getSchoolIdFromDeptVal(val);
                if(this.$util.isEmpty(schoolId)){
                    this.cardNoOptions = [];
                    this.form.cardNo = "";
                    this.cardNoSchoolId = "";
                    this.cardNoPage = 1;
                    this.cardNoTotal = 0;
                    return;
                }
                this.cardNoSchoolId = schoolId;
                this.resetCardNoQuery();
                this.queryCardNoList(false, true);
            },
            resetCardNoQuery(){
                this.cardNoKeyword = "";
                this.cardNoPage = 1;
                this.cardNoTotal = 0;
                this.cardNoOptions = [];
            },
            onCardNoRemote(query){
                this.cardNoKeyword = query || "";
                this.cardNoPage = 1;
                this.cardNoOptions = [];
                this.queryCardNoList(false, true);
            },
            onCardNoVisibleChange(visible){
                if(!visible){
                    return;
                }
                if(this.cardNoOptions.length === 0){
                    this.cardNoPage = 1;
                    this.queryCardNoList(false, true);
                }
                this.$nextTick(() => {
                    this.bindCardNoDropdownScroll();
                });
            },
            bindCardNoDropdownScroll(){
                const wrap = document.querySelector('.student-cardno-dropdown-update .el-select-dropdown__wrap');
                if(!wrap || wrap.__cardNoScrollBound){
                    return;
                }
                wrap.__cardNoScrollBound = true;
                wrap.addEventListener('scroll', () => {
                    if(this.cardNoLoading){
                        return;
                    }
                    if(this.cardNoTotal && this.cardNoOptions.length >= this.cardNoTotal){
                        return;
                    }
                    const reachBottom = wrap.scrollHeight - wrap.scrollTop - wrap.clientHeight <= 5;
                    if(reachBottom){
                        this.cardNoPage = this.cardNoPage + 1;
                        this.queryCardNoList(true, true);
                    }
                });
            },
            // isAppend: 是否追加；includeCurrent: 是否强制包含当前已绑定卡号
            queryCardNoList(isAppend, includeCurrent){
                if(this.$util.isEmpty(this.cardNoSchoolId)){
                    return;
                }
                let url = this.cardManageUrl;
                let data = {
                    isPage: 1,
                    page: this.cardNoPage,
                    limit: this.cardNoPageSize,
                    deptId: this.cardNoSchoolId,
                    cardNo: this.cardNoKeyword,
                    studentName: "",
                    useFlag: 0
                };
                this.cardNoLoading = true;
                this.apiPost(url, data).then((res) => {
                    this.cardNoLoading = false;
                    if(res.status == 200){
                        let list = res.data.list || res.data.data || [];
                        this.cardNoTotal = res.data.total || 0;
                        let enabled = list.filter(x => (x && (x.status == null || x.status == 1)));
                        let unused = enabled.filter(x => (x.useFlag == null || x.useFlag == 0));
                        let next = unused.length > 0 ? unused : enabled;
                        let options = next;
                        if(isAppend){
                            let map = {};
                            let merged = this.cardNoOptions.concat(next);
                            options = merged.filter(x => {
                                let key = x && x.cardNo ? x.cardNo : "";
                                if(this.$util.isEmpty(key)){
                                    return false;
                                }
                                if(map[key]){
                                    return false;
                                }
                                map[key] = true;
                                return true;
                            });
                        }
                        if(includeCurrent && this.$util.isNotEmpty(this.form.cardNo) && !options.some(x => x && x.cardNo === this.form.cardNo)){
                            options = [{ cardNo: this.form.cardNo }].concat(options);
                        }
                        this.cardNoOptions = options;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                    this.cardNoLoading = false;
                });
            },
            getName(setVal,data){
                var arr = new Array();
                if(this.$util.isNotEmpty(data) && this.$util.isNotEmpty(setVal)){
                   let valArr = setVal.split(",");
                   for(var i = 0;i < valArr.length;i++){
                       var tempArr = new Array();
                       this.recursionCascader(valArr[i], data, tempArr, data);
                       arr.push(tempArr.reverse());
                   }
                }
                return arr;
            },
            recursionCascader(val, cdata, tempArr, data){
                if(val == 0){
                    return;
                }
                for(var i=0; i<cdata.length;i++){
                   if(cdata[i].value == val){
                       tempArr.push(val);
                       this.recursionCascader(cdata[i].parentId, data, tempArr, data);
                   }
                   if(cdata[i].children && cdata[i].children.length) {
                       this.recursionCascader(val, cdata[i].children, tempArr, data);
                   }
                }
            },
            filterCascader(data){
                if(this.$util.isEmpty(data)){
                    return ''
                }
                if(data.length == 0){
                    return ''
                }
                let strArr = []
                for(let i=0;i<data.length;i++){
                    strArr.push(data[i][data[i].length-1])
                }
                return strArr.join(',')
            },
            save(){
                this.$refs['form'].validate((valid) => {
                    if(!valid){
                        return;
                    }
                    let deptId = this.filterCascader(this.form.deptId);
                    this.loading=true;
                    let url = this.userUpdateUrl;
                    let data = {
                        id:this.form.id,
                        studentId:this.form.studentId,
                        name:this.form.name,
                        cardNo:this.form.cardNo,
                        personType:1,
                        deptIdstr:deptId,
                        sex:this.form.sex,
                        identityCard:this.form.identityCard,
                        classNo:this.form.classNo,
                        studentType:this.form.studentType,
                        roomNumber:this.form.roomNumber,
                        postDescrible:this.form.postDescrible,
                        office:this.form.office,
                        expertise:this.form.expertise,
                        hobby:this.form.hobby,
                        graduationDate:this.form.graduationDate,
                        orderNum:this.form.orderNum,
                        mobile1:this.form.mobile1,
                    };
                    this.apiPost(url,data).then((res)=>{
                        this.loading=false;
                        if(res.status == 200){
                            this.$commonFn.showTip(res.message,1);
                            this.visible=false;
                            this.$parent.getData();
                        }else{
                            this.$commonFn.showTip(res.message,3);
                        }
                    },(err)=>{
                        console.log(err);
                        this.loading=false;
                    })
                });
            }
        },
        mixins: [http]
    }
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/page/sys/student/Update.vue